import { Grid, MenuItem } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import FilterSelect from "../../../../components/select/filterSelect";
import InputTextField from "../../../../components/input/inputTextField";
import { IMainFormsCreateClassRoom } from "../../../../domains/class-room";
import FormAddNewAdvisor from "./FormAddNewAdvisor";
import { degreeApi } from "../../../../api/degree/degree.api";
import { facultyApi } from "../../../../api/factulty/factulty.api";
import { EmployeeApi } from "../../../../api/employee/employee.api";
import { advisorFormApi } from "../../../../api/advisor-form/advisor-form.api";
import StateComponents from "../../../../components/state-component/StateComponents";
import { AcademicYearApi, getAcademicYearListType } from "../../../../api/academic-year/academic-year.api";
import moment from "moment";
import { CourseOfStudyApi, getOneLunchType } from "../../../../api/course-of-study/course-of-study.api";
import { useTranslation } from "react-i18next";

const MainFormsCreateClass = ({
  inputValue,
  setInputValue,
  isCanEdit,
  action,
  isViewOnly,
  errorMessage,
  handleClearError
}: IMainFormsCreateClassRoom) => {
  const { t } = useTranslation();
  const [dataAcademicYear, setDataAcademicYear] = useState<any[]>([]);
  const [dataDegree, setDataDegree] = useState<any[]>([]);
  const [dataFaculty, setDataFaculty] = useState<any[]>([]);
  const [dataAdvisorForm, setDataAdvisorForm] = useState<any[]>([]);
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const [academic_year, set_academic_year] = useState<any[]>([]);
  const [search_academic_year, set_search_academic_year] = useState<string>("");
  const [rooms, set_rooms] = useState<any[]>([]);


  const [isShowModalSearchAdvisor, setIsShowModalSearchAdvisor] =
    useState<boolean>(false);

  const [actionModalType, setActionModalType] = useState<string>("create");

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5;
    const endYear = currentYear + 5;
    const buddhistYearOffset = 543;

    const academicYears = [];
    for (let year = startYear; year <= endYear; year++) {
      academicYears.push(year + buddhistYearOffset); // Convert to Buddhist calendar year
    }

    setDataAcademicYear(academicYears);
  }, []);

  // useEffect(() => {
  //   if (dataAcademicYear && dataAcademicYear.length > 0) {
  //     setInputValue((prev: any) => {
  //       return {
  //         ...prev,
  //         start_academic_year: dataAcademicYear[0],
  //         end_academic_year: dataAcademicYear[0] + 1,
  //       };
  //     });
  //   }
  // }, [dataAcademicYear]);


  const handleGetAcademicYear = useCallback(async () => {
    let query: getAcademicYearListType = {
      page: 1,
      limit: 10,
    }
    if (search_academic_year) query.search = search_academic_year;
    await AcademicYearApi.getOnlyActiveAcademicYear(query).then((res) => {
      if (res.status < 300) {
        const response = res.data?.data?.items || [];
        // console.log(response,'response')
        set_academic_year(response);
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [search_academic_year])

  const getDataDegree = async () => {
    await degreeApi.getDegree().then((res) => {
      if (res.status < 300) {
        const data = res.data
        setDataDegree(data.data);
      } else {
        setDataDegree([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  const getDataFaculty = async (id_degree?: number) => {
    await facultyApi.listFaculty(id_degree).then((res) => {
      if (res.status < 300) {
        const data = res.data;
        const response = data?.data || [];
        setDataFaculty(response);
      } else {
        setDataFaculty([]);
      }
    }).catch((err) => {
      console.log(err)
    })
  };

  useEffect(() => {
    if (inputValue && inputValue.degree) {
      getDataFaculty(inputValue.degree);
    }
  }, [inputValue.degree]);

  const getDataEmployee = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await EmployeeApi.list(query);
    const data = res.data;
    if (data.status < 300) {
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  };

  const getDataAdvisorFormEvaluation = async () => {
    let query: any = {
      page: 1,
      limit: 1000000,
    };

    const res = await advisorFormApi.getAllAdvisorForm(query);
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorForm(data.data.items);
    } else {
      setDataAdvisorForm([]);
    }
  };


  const handleGetRooms = useCallback(async (id_academic_year: number) => {
    let query: getOneLunchType = {}
    if (inputValue.degree) query.id_degree = inputValue.degree;
    if (inputValue.faculty) query.id_faculty = inputValue.faculty;
    await CourseOfStudyApi.academicDetailLunch(id_academic_year, query).then((res) => {
      if (res.status < 300) {
        const response = res.data?.data || [];
        set_rooms(response);
        // console.log(response, 'response')
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [inputValue.start_academic_year, academic_year?.length, inputValue.degree, inputValue.faculty])

  useEffect(() => {
    handleGetAcademicYear();
  }, [handleGetAcademicYear])

  useEffect(() => {
    getDataDegree();
    getDataEmployee();
    getDataAdvisorFormEvaluation();
  }, []);

  useEffect(() => {
    if (inputValue.start_academic_year && academic_year?.length > 0) {
      const id_academic_year = academic_year?.find((x) => x?.academic_year == inputValue.start_academic_year)?.id_academic_year;
      handleGetRooms(id_academic_year);
    }
  }, [handleGetRooms])

  const handleChangeValue = (name: string, value: any) => {
    handleClearError?.();
    setInputValue((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  console.log(String(rooms?.find((x) => x)?.list_room || "")?.split(",")?.find((x) => x == inputValue.class), 'String(rooms?.find((x) => x)?.list_room || "")?.split(",")?.find((x) => x == inputValue.class)')
  console.log(inputValue, 'inputValue')
  return (
    <>
      <Grid container spacing={2}>

        <Grid
          item
          lg={3}
          md={6}
          sm={12}
          xs={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <StateComponents
            typeProps={[
              {
                seq: 1,
                type: "AUTO-COMPLETE",
                gridProps: {
                  xs: 12
                },
                fieldProps: {
                  heading: t("ปีการศึกษาเริ่มต้น"),
                  placeholder: t("กรุณาเลือกปีการศึกษาเริ่มต้น"),
                  getOptionLabel: (op) => String(op?.academic_year || ""),
                  labelId: "start_academic_year",
                  onChange: (_, val) => {
                    handleChangeValue("start_academic_year", val?.academic_year ?? null);
                    handleChangeValue("id_academic_year", val?.id_academic_year ?? null);
                    handleChangeValue("end_academic_year", val?.academic_year_end ? moment(val?.academic_year_end).year() : null);
                  },
                  options: academic_year || [],
                  required: true,
                  disabled: !isCanEdit,
                  helperText: errorMessage.includes("start_academic_year") ? "Start Academic Year is required." : "",
                  value: academic_year?.find((x) => x?.academic_year == inputValue.start_academic_year) || null
                }
              }
            ]}
          />
          {/* <FilterSelect
            heading={"กรุณาเลือกปีการศึกษาเริ่มต้น"}
            value={inputValue.start_academic_year ?? ""}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValue("start_academic_year", e.target.value);
            }}
            helperText={
              errorMessage.includes("start_academic_year")
                ? "Start Academic Year is required."
                : ""
            }
            required
            disabled={!isCanEdit}
            placeholder="กรุณาเลือกปีการศึกษาเริ่มต้น"
            options={[
              // {
              //   id_academic_year: "",
              //   academic_year_name: "ปีการศึกษาเริ่มต้น",
              // },
              ...dataAcademicYear.map((year) => ({
                id_academic_year: year.toString(), // Ensure year is a string
                academic_year_name: year.toString(), // Ensure year is a string
              })),
            ].map((option: any, index: number) => (
              <MenuItem value={option.id_academic_year} key={index}>
                {option.academic_year_name}
              </MenuItem>
            ))}
            labelId={""}
            selectId={""}
          /> */}
        </Grid>

        <Grid
          item
          lg={3}
          md={6}
          sm={12}
          xs={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <StateComponents
            typeProps={[
              {
                seq: 1,
                type: "TEXT_FIELD",
                gridProps: {
                  xs: 12
                },
                fieldProps: {
                  heading: t("ปีการศึกษาสิ้นสุด"),
                  placeholder: t("กรุณาเลือกปีการศึกษาสิ้นสุด"),
                  // getOptionLabel: (op) => String(op?.academic_year || ""),
                  // labelId: "end_academic_year",
                  onChange: () => { },
                  // options: academic_year || [],
                  disabled: true,
                  value: inputValue.end_academic_year || ""
                }
              }
            ]}
          />
          {/* <StateComponents
            typeProps={[
              {
                seq: 1,
                type: "AUTO-COMPLETE",
                gridProps: {
                  xs: 12
                },
                fieldProps: {
                  heading: "ปีการศึกษาสิ้นสุด",
                  placeholder: "กรุณาเลือกปีการศึกษาสิ้นสุด",
                  getOptionLabel: (op) => String(op?.academic_year || ""),
                  labelId: "end_academic_year",
                  onChange: () => { },
                  options: academic_year || [],
                  disabled: true,
                  value: academic_year?.find((x) => x?.id_academic_year == inputValue.end_academic_year) || null
                }
              }
            ]}
          /> */}
          {/* <FilterSelect
            heading={"ปีการศึกษาสิ้นสุด"}
            value={inputValue.end_academic_year ?? ""}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValue("end_academic_year", e.target.value);
            }}
            helperText={
              errorMessage.includes("end_academic_year")
                ? "End Academic Year is required."
                : ""
            }
            required
            disabled={!isCanEdit}
            placeholder="ปีการศึกษาสิ้นสุด"
            options={[
              // {
              //   id_academic_year: "",
              //   academic_year_name: "ปีการศึกษาสิ้นสุด",
              // },
              ...dataAcademicYear.map((year) => ({
                id_academic_year: year.toString(), // Ensure year is a string
                academic_year_name: year.toString(), // Ensure year is a string
              })),
            ].map((option: any, index: number) => (
              <MenuItem value={option.id_academic_year} key={index}>
                {option.academic_year_name}
              </MenuItem>
            ))}
            labelId={""}
            selectId={""}
          /> */}

        </Grid>

        <Grid
          item
          lg={3}
          md={6}
          sm={12}
          xs={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <StateComponents
            typeProps={[
              {
                seq: 1,
                type: "AUTO-COMPLETE",
                gridProps: {
                  xs: 12
                },
                fieldProps: {
                  heading: t("ระดับ"),
                  placeholder: t("กรุณาระดับ"),
                  getOptionLabel: (op) => String(op?.degree_name || ""),
                  labelId: "degree",
                  onChange: (_, val) => {
                    handleChangeValue("degree", val?.id_degree ?? null);
                  },
                  options: dataDegree || [],
                  required: true,
                  disabled: !isCanEdit || !inputValue.start_academic_year,
                  helperText: errorMessage.includes("faculty") ? "Faculty is required." : "",
                  value: dataDegree?.find((x) => x?.id_degree == inputValue.degree) || null
                }
              }
            ]}
          />
          {/* <FilterSelect
            heading={"ระดับ"}
            value={inputValue.degree ?? ""}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValue("degree", e.target.value);
              getDataFaculty(+e.target.value);
            }}
            helperText={
              errorMessage.includes("degree") ? "Degree is required." : ""
            }
            required
            disabled={!isCanEdit}
            placeholder="กรุณาเลือกระดับ"
            options={[
              {
                id_degree: "",
                degree_name: "ทุกระดับ",
              },
              ...dataDegree.map((item) => ({
                id_degree: item.id_degree,
                degree_name: item.degree_name,
              })),
            ].map((option: any, index: number) => (
              <MenuItem value={option.id_degree} key={index + 1}>
                {option.degree_name}
              </MenuItem>
            ))}
            labelId={""}
            selectId={""}
          /> */}
        </Grid>

        <Grid
          item
          lg={3}
          md={6}
          sm={12}
          xs={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <StateComponents
            typeProps={[
              {
                seq: 1,
                type: "AUTO-COMPLETE",
                gridProps: {
                  xs: 12
                },
                fieldProps: {
                  heading: t("หลักสูตร"),
                  placeholder: t("กรุณาหลักสูตร"),
                  getOptionLabel: (op) => String(op?.faculty_name || ""),
                  labelId: "faculty",
                  onChange: (_, val) => {
                    handleChangeValue("faculty", val?.id_faculty ?? null);
                  },
                  options: dataFaculty || [],
                  required: true,
                  disabled: !isCanEdit || !inputValue.degree,
                  helperText: errorMessage.includes("faculty") ? "Faculty is required." : "",
                  value: dataFaculty?.find((x) => x?.id_faculty == inputValue.faculty) || null
                }
              }
            ]}
          />
          {/* <FilterSelect
            heading={"คณะ"}
            value={inputValue.faculty ?? ""}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValue("faculty", e.target.value);
            }}
            helperText={
              errorMessage.includes("faculty") ? "Faculty is required." : ""
            }
            required
            disabled={!isCanEdit}
            placeholder="กรุณาเลือกคณะ"
            options={[
              {
                id_faculty: "",
                faculty_name: "ทุกคณะ",
              },
              ...dataFaculty.map((item) => ({
                id_faculty: item.id_faculty, // Ensure year is a string
                faculty_name: item.faculty_name,
              })),
            ].map((option: any, index: number) => (
              <MenuItem value={option.id_faculty} key={index + 1}>
                {option.faculty_name}
              </MenuItem>
            ))}
            labelId={"id_faculty"}
            selectId={"id_faculty_s"}
          /> */}
        </Grid>

        <Grid
          item
          lg={3}
          md={6}
          sm={12}
          xs={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <StateComponents
            typeProps={[
              {
                seq: 1,
                type: "AUTO-COMPLETE",
                gridProps: {
                  xs: 12
                },
                fieldProps: {
                  heading: t("ห้อง"),
                  placeholder: t("ห้อง"),
                  getOptionLabel: (op) => String(op?.room || ""),
                  labelId: "class",
                  onChange: (_, val) => {
                    // console.log(val,'val')
                    handleChangeValue("class", val?.value || "");
                  },
                  options: rooms?.find((x) => x)?.list_room?.length > 0 ? String(rooms?.find((x) => x)?.list_room || "").split(",").map((list) => {
                    return {
                      value: list,
                      room: list
                    }
                  }) : [],
                  required: true,
                  disabled: rooms?.length == 0 || !isCanEdit,
                  helperText: errorMessage.includes("class") ? "Class is required." : "",
                  value:
                    String(rooms?.find((x) => x)?.list_room || "")?.split(",")?.map((list) => {
                      return {
                        value: list,
                        room: list
                      }
                    }).find((x) => x.value == inputValue.class)
                    || null
                }
              }
            ]}
          />
          {/* <InputTextField
            heading={"ห้อง"}
            placeholder={"ห้อง"}
            value={inputValue.class ?? ""}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValue("class", e.target.value);
            }}
            helperText={
              errorMessage.includes("class") ? "Class is required." : ""
            }
            required
            disabled={!isCanEdit}
          /> */}
        </Grid>

        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <FormAddNewAdvisor
            setIsOpenModal={(isOpen: boolean) =>
              setIsShowModalSearchAdvisor(isOpen)
            }
            isOpenModal={isShowModalSearchAdvisor}
            setActionModalType={(value: string) => setActionModalType(value)}
            actionModalType={actionModalType}
            inputValue={inputValue}
            setInputValue={setInputValue}
            isViewOnly={isViewOnly}
            isCanEdit={isCanEdit}
          />
        </Grid>

        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{
            alignSelf: "end",
          }}
        >
          <FilterSelect
            heading={t("เลือกแบบฟอร์มประเมินอาจารย์ที่ปรึกษาประจำชั้นเรียน")}
            value={inputValue.evaluation_form_type ?? ""}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              handleChangeValue("evaluation_form_type", e.target.value);
            }}
            helperText={
              errorMessage.includes("evaluation_form_type")
                ? "Evaluation Form is required."
                : ""
            }
            required
            disabled={!isCanEdit}
            options={[
              {
                value: 0,
                label: t("เลือกแบบฟอร์มประเมิน"),
              },
              ...dataAdvisorForm.map((item, index) => ({
                value: item.id_advisor_form,
                label: item.advisor_form_name,
              })),
              // dataAdvisorForm
            ].map((option: any) => (
              <MenuItem value={option.value} key={option.value}>
                {option.label}
              </MenuItem>
            ))}
            labelId={""}
            selectId={""}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default MainFormsCreateClass;
